import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { ConferenceContext } from '../../../shared/context/ConferenceContext';

const useStyles = makeStyles(() => ({
  iframe: {
    position: 'relative',
    top: '-100px',
    bottom: '-100px',
    width: '100%',
    height: '500px',
    border: 'none',
  },
  iframeHolder: {
    overflow: 'hidden',
  },
}));

const PollEmbed = withRouter((props) => {
  const classes = useStyles();
  const { conferenceState, actions } = useContext(ConferenceContext); // Hämta Context

  useEffect(() => {
    actions.loadConferenceDetail(props.conferencename);
  }, []);

  return conferenceState.conferenceDetailLoaded ? (
    <Box>
      <Paper>
        <Box className={classes.iframeHolder}>
          <iframe
            className={classes.iframe}
            width="320"
            height="600"
            src="https://www.menti.com/ekjdr8uwi2"
          />
        </Box>
      </Paper>
    </Box>
  ) : (
    <Box align="center">Could not load conference</Box>
  );
});

export default PollEmbed;
